import { render, staticRenderFns } from "./OneMonthAddV2.vue?vue&type=template&id=fa82e89e&"
import script from "./OneMonthAddV2.vue?vue&type=script&lang=ts&"
export * from "./OneMonthAddV2.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports